export default "https://statics.cloudfastin.top/static/v1.27.34/store/images/eBay.png?550c4cb0a7121a26aed29ca26bb03592";